//优惠券vuex
import {
  listCoupon,
  exchangeCoupon,
  drawCoupon,
  listMyCoupon
} from '@/api/coupon';

const getDefaultState = () => {
  return {
    total: 0,
    couponList: [],
    page: 1,
    limit: 9999,
    myTotal: 0,
    myCouponList: [],
    myPage: 1,
    myLimit: 9999,
    status:0
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_COUPONLIST: (state, couponList) => {
      console.info(couponList)
      var couponLists = []
      couponList.forEach(item=>{
        if(item.is_draw == 0){
          couponLists.push(item)
        }
      })
      state.total = couponLists.length
      state.couponList = couponLists
    },
    SET_PAGE: (state, page) => {
      state.page = page
    },
    SET_LIMIT: (state, limit) => {
      state.limit = limit
    },
    SET_MY_TOTAL: (state, myTotal) => {
      state.myTotal = myTotal
    },
    SET_MY_COUPONLIST: (state, myCouponList) => {
      state.myCouponList = myCouponList
    },
    SET_MY_PAGE: (state, myPage) => {
      state.myPage = myPage
    },
    SET_MY_LIMIT: (state, myLimit) => {
      state.myLimit = myLimit
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    RESET_STATE: (state, payload) => {
      Object.assign(state, payload)
    }
  },
  getters: {
    total: state => state.total,
    couponList: state => state.couponList,
    myTotal: state => state.myTotal,
    myCouponList: state => state.myCouponList
  },
  actions: {
    GetCouponList({
      commit,
      state
    }) { //获取优惠券列表
      const {
        page,
        limit
      } = state
      listCoupon({
        page,
        limit
      }).then((res) => {
        if (res.code == 200) {
          const {
            count,
            data
          } = res;
          commit('SET_COUPONLIST', data)
          // commit('SET_TOTAL', count)
        }
      });
    },
    GetMyCouponList({
      commit,
      state
    }) { //获取优惠券列表
      const {
        myPage,
        myLimit,
        status
      } = state
      listMyCoupon({
        page:myPage,
        limit:myLimit,
        status
      }).then((res) => {
        if (res.code == 200) {
          const {
            count,
            data
          } = res;
          console.log(res)
          commit('SET_MY_COUPONLIST', data)
          commit('SET_MY_TOTAL', count)
        }
      });
    },
    ExchangeCoupon({
      commit,
      state
    }, payload) { //兑换优惠券
      const {
        exchange_code
      } = payload
      return new Promise((resolve, reject) => {
        exchangeCoupon({
          exchange_code
        }).then((res) => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DrawCoupon({
      dispatch,
      commit,
      state
    }, payload) { //领取优惠券
      const { page,limit } = state
      const {
        coupon_id
      } = payload
      return new Promise((resolve, reject) => {
        drawCoupon({
          coupon_id
        }).then((res) => {
          dispatch('GetCouponList',{ page,limit })
          dispatch('GetMyCouponList',{ page,limit })
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetCouponListFilter({
      commit,
      state
    }, payload) { //设置优惠券查询条件
      const {
        page,
        limit
      } = payload
      commit('SET_PAGE', page)
      commit('SET_LIMIT', limit)
    },
    SetMyCouponListFilter({
      commit,
      state
    }, payload) { //设置优惠券查询条件
      const {
        page,
        limit,
        status
      } = payload
      commit('SET_MY_PAGE', page)
      commit('SET_MY_LIMIT', limit)
      commit('SET_STATUS', status)
    },
    ResetCouponList({
      commit,
      state
    }) { //重置优惠券列表
      commit('RESET_STATE', getDefaultState())
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/coupon.js